import BasicRouterView from "../../components/BasicRouterView.vue";

const indRoutes = {
  path: "ind",
  redirect: { name: "ind-historico" },
  meta: {
    label: "Indicadores",
    icon: "groups",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "indicadores/consumo",
      name: "ind-consumo",
      meta: {
        label: "Consumo",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/Consumo.vue"),
    },
    {
      path: "indicadores/estoque",
      name: "ind-estoque",
      meta: {
        label: "Estoque",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/Estoque.vue"),
    },
    {
      path: "indicadores/estoque-movimento/:id",
      name: "ind-estoque-movimento",
      meta: {
        label: "Estoque",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/EstoqueMovimento.vue"),
    },
    {
      path: "indicadores/master-data",
      name: "ind-master-data",
      meta: {
        label: "Master Data",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/MasterData.vue"),
    },

    {
      path: "indicadores/indicadores",
      name: "ind-indicadores",
      meta: {
        label: "Indicadores",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/Indicadores.vue"),
    },
    {
      path: "indicadores/status-troca",
      name: "ind-status-troca",
      meta: {
        label: "Status Troca",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/StatusTroca.vue"),
    },
    {
      path: "indicadores/mrp",
      name: "ind-mrp",
      meta: {
        label: "MRP",
        icon: "find_in_page",
        show: true,
      },
      component: () => import(/* webpackChunkName: "cse" */ "./views/MRP.vue"),
    },
    {
      path: "indicadores/verificacao-movimentacao-estoque",
      name: "ind-verificacao-movimentacao-estoque",
      meta: {
        label: "Verificação de Movimentação de Estoque",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "cse" */ "./views/VerificacaoMovimentacaoEstoque.vue"
        ),
    },
  ],
};

export default indRoutes;
